module.exports = __webpack_public_path__ + "static/media/image-3.1a6f1f9b.webp";